/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from 'protobufjs/minimal';

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots['price-alerts'] || ($protobuf.roots['price-alerts'] = {});

export const PriceAlerts = ($root.PriceAlerts = (() => {
  /**
   * Namespace PriceAlerts.
   * @exports PriceAlerts
   * @namespace
   */
  const PriceAlerts = {};

  PriceAlerts.AlertService = (function () {
    /**
     * Constructs a new AlertService service.
     * @memberof PriceAlerts
     * @classdesc Represents an AlertService
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function AlertService(rpcImpl, requestDelimited, responseDelimited) {
      $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
    }

    (AlertService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AlertService;

    /**
     * Creates new AlertService service using the specified rpc implementation.
     * @function create
     * @memberof PriceAlerts.AlertService
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {AlertService} RPC service. Useful where requests and/or responses are streamed.
     */
    AlertService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
      return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link PriceAlerts.AlertService#addAlert}.
     * @memberof PriceAlerts.AlertService
     * @typedef addAlertCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {PriceAlerts.PostAlertResponse} [response] PostAlertResponse
     */

    /**
     * Calls addAlert.
     * @function addAlert
     * @memberof PriceAlerts.AlertService
     * @instance
     * @param {PriceAlerts.IPostAlertRequest} request PostAlertRequest message or plain object
     * @param {PriceAlerts.AlertService.addAlertCallback} callback Node-style callback called with the error, if any, and PostAlertResponse
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (AlertService.prototype.addAlert = function addAlert(request, callback) {
        return this.rpcCall(
          addAlert,
          $root.PriceAlerts.PostAlertRequest,
          $root.PriceAlerts.PostAlertResponse,
          request,
          callback,
        );
      }),
      'name',
      { value: 'addAlert' },
    );

    /**
     * Calls addAlert.
     * @function addAlert
     * @memberof PriceAlerts.AlertService
     * @instance
     * @param {PriceAlerts.IPostAlertRequest} request PostAlertRequest message or plain object
     * @returns {Promise<PriceAlerts.PostAlertResponse>} Promise
     * @variation 2
     */

    return AlertService;
  })();

  PriceAlerts.Alert = (function () {
    /**
     * Properties of an Alert.
     * @memberof PriceAlerts
     * @interface IAlert
     * @property {string|null} [uuid] Alert uuid
     * @property {string|null} [symbol] Alert symbol
     * @property {string|null} [callback] Alert callback
     * @property {string|null} [triggeredDate] Alert triggeredDate
     * @property {PriceAlerts.Alert.Status|null} [status] Alert status
     * @property {string|null} [createdDate] Alert createdDate
     * @property {PriceAlerts.IPriceAlert|null} [priceAlert] Alert priceAlert
     */

    /**
     * Constructs a new Alert.
     * @memberof PriceAlerts
     * @classdesc Represents an Alert.
     * @implements IAlert
     * @constructor
     * @param {PriceAlerts.IAlert=} [properties] Properties to set
     */
    function Alert(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Alert uuid.
     * @member {string} uuid
     * @memberof PriceAlerts.Alert
     * @instance
     */
    Alert.prototype.uuid = '';

    /**
     * Alert symbol.
     * @member {string} symbol
     * @memberof PriceAlerts.Alert
     * @instance
     */
    Alert.prototype.symbol = '';

    /**
     * Alert callback.
     * @member {string} callback
     * @memberof PriceAlerts.Alert
     * @instance
     */
    Alert.prototype.callback = '';

    /**
     * Alert triggeredDate.
     * @member {string} triggeredDate
     * @memberof PriceAlerts.Alert
     * @instance
     */
    Alert.prototype.triggeredDate = '';

    /**
     * Alert status.
     * @member {PriceAlerts.Alert.Status} status
     * @memberof PriceAlerts.Alert
     * @instance
     */
    Alert.prototype.status = 0;

    /**
     * Alert createdDate.
     * @member {string} createdDate
     * @memberof PriceAlerts.Alert
     * @instance
     */
    Alert.prototype.createdDate = '';

    /**
     * Alert priceAlert.
     * @member {PriceAlerts.IPriceAlert|null|undefined} priceAlert
     * @memberof PriceAlerts.Alert
     * @instance
     */
    Alert.prototype.priceAlert = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Alert type.
     * @member {"priceAlert"|undefined} type
     * @memberof PriceAlerts.Alert
     * @instance
     */
    Object.defineProperty(Alert.prototype, 'type', {
      get: $util.oneOfGetter(($oneOfFields = ['priceAlert'])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Alert instance using the specified properties.
     * @function create
     * @memberof PriceAlerts.Alert
     * @static
     * @param {PriceAlerts.IAlert=} [properties] Properties to set
     * @returns {PriceAlerts.Alert} Alert instance
     */
    Alert.create = function create(properties) {
      return new Alert(properties);
    };

    /**
     * Encodes the specified Alert message. Does not implicitly {@link PriceAlerts.Alert.verify|verify} messages.
     * @function encode
     * @memberof PriceAlerts.Alert
     * @static
     * @param {PriceAlerts.IAlert} message Alert message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Alert.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.uuid != null && Object.hasOwnProperty.call(message, 'uuid'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.uuid);
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.symbol);
      if (message.callback != null && Object.hasOwnProperty.call(message, 'callback'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.callback);
      if (message.triggeredDate != null && Object.hasOwnProperty.call(message, 'triggeredDate'))
        writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.triggeredDate);
      if (message.status != null && Object.hasOwnProperty.call(message, 'status'))
        writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.status);
      if (message.createdDate != null && Object.hasOwnProperty.call(message, 'createdDate'))
        writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.createdDate);
      if (message.priceAlert != null && Object.hasOwnProperty.call(message, 'priceAlert'))
        $root.PriceAlerts.PriceAlert.encode(
          message.priceAlert,
          writer.uint32(/* id 100, wireType 2 =*/ 802).fork(),
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Alert message, length delimited. Does not implicitly {@link PriceAlerts.Alert.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceAlerts.Alert
     * @static
     * @param {PriceAlerts.IAlert} message Alert message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Alert.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Alert message from the specified reader or buffer.
     * @function decode
     * @memberof PriceAlerts.Alert
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceAlerts.Alert} Alert
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Alert.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.PriceAlerts.Alert();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.uuid = reader.string();
            break;
          case 2:
            message.symbol = reader.string();
            break;
          case 3:
            message.callback = reader.string();
            break;
          case 8:
            message.triggeredDate = reader.string();
            break;
          case 9:
            message.status = reader.int32();
            break;
          case 10:
            message.createdDate = reader.string();
            break;
          case 100:
            message.priceAlert = $root.PriceAlerts.PriceAlert.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an Alert message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceAlerts.Alert
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceAlerts.Alert} Alert
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Alert.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Alert message.
     * @function verify
     * @memberof PriceAlerts.Alert
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Alert.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      let properties = {};
      if (message.uuid != null && message.hasOwnProperty('uuid'))
        if (!$util.isString(message.uuid)) return 'uuid: string expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.callback != null && message.hasOwnProperty('callback'))
        if (!$util.isString(message.callback)) return 'callback: string expected';
      if (message.triggeredDate != null && message.hasOwnProperty('triggeredDate'))
        if (!$util.isString(message.triggeredDate)) return 'triggeredDate: string expected';
      if (message.status != null && message.hasOwnProperty('status'))
        switch (message.status) {
          default:
            return 'status: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.createdDate != null && message.hasOwnProperty('createdDate'))
        if (!$util.isString(message.createdDate)) return 'createdDate: string expected';
      if (message.priceAlert != null && message.hasOwnProperty('priceAlert')) {
        properties.type = 1;
        {
          let error = $root.PriceAlerts.PriceAlert.verify(message.priceAlert);
          if (error) return 'priceAlert.' + error;
        }
      }
      return null;
    };

    /**
     * Creates an Alert message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceAlerts.Alert
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceAlerts.Alert} Alert
     */
    Alert.fromObject = function fromObject(object) {
      if (object instanceof $root.PriceAlerts.Alert) return object;
      let message = new $root.PriceAlerts.Alert();
      if (object.uuid != null) message.uuid = String(object.uuid);
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.callback != null) message.callback = String(object.callback);
      if (object.triggeredDate != null) message.triggeredDate = String(object.triggeredDate);
      switch (object.status) {
        case 'UNKNOWN':
        case 0:
          message.status = 0;
          break;
        case 'ACTIVE':
        case 1:
          message.status = 1;
          break;
        case 'TRIGGERED':
        case 2:
          message.status = 2;
          break;
      }
      if (object.createdDate != null) message.createdDate = String(object.createdDate);
      if (object.priceAlert != null) {
        if (typeof object.priceAlert !== 'object') throw TypeError('.PriceAlerts.Alert.priceAlert: object expected');
        message.priceAlert = $root.PriceAlerts.PriceAlert.fromObject(object.priceAlert);
      }
      return message;
    };

    /**
     * Creates a plain object from an Alert message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceAlerts.Alert
     * @static
     * @param {PriceAlerts.Alert} message Alert
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Alert.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.uuid = '';
        object.symbol = '';
        object.callback = '';
        object.triggeredDate = '';
        object.status = options.enums === String ? 'UNKNOWN' : 0;
        object.createdDate = '';
      }
      if (message.uuid != null && message.hasOwnProperty('uuid')) object.uuid = message.uuid;
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.callback != null && message.hasOwnProperty('callback')) object.callback = message.callback;
      if (message.triggeredDate != null && message.hasOwnProperty('triggeredDate'))
        object.triggeredDate = message.triggeredDate;
      if (message.status != null && message.hasOwnProperty('status'))
        object.status = options.enums === String ? $root.PriceAlerts.Alert.Status[message.status] : message.status;
      if (message.createdDate != null && message.hasOwnProperty('createdDate'))
        object.createdDate = message.createdDate;
      if (message.priceAlert != null && message.hasOwnProperty('priceAlert')) {
        object.priceAlert = $root.PriceAlerts.PriceAlert.toObject(message.priceAlert, options);
        if (options.oneofs) object.type = 'priceAlert';
      }
      return object;
    };

    /**
     * Converts this Alert to JSON.
     * @function toJSON
     * @memberof PriceAlerts.Alert
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Alert.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Status enum.
     * @name PriceAlerts.Alert.Status
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ACTIVE=1 ACTIVE value
     * @property {number} TRIGGERED=2 TRIGGERED value
     */
    Alert.Status = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNKNOWN')] = 0;
      values[(valuesById[1] = 'ACTIVE')] = 1;
      values[(valuesById[2] = 'TRIGGERED')] = 2;
      return values;
    })();

    return Alert;
  })();

  PriceAlerts.PriceAlert = (function () {
    /**
     * Properties of a PriceAlert.
     * @memberof PriceAlerts
     * @interface IPriceAlert
     * @property {number|null} [price] PriceAlert price
     * @property {PriceAlerts.PriceAlert.Crossing|null} [crossing] PriceAlert crossing
     */

    /**
     * Constructs a new PriceAlert.
     * @memberof PriceAlerts
     * @classdesc Represents a PriceAlert.
     * @implements IPriceAlert
     * @constructor
     * @param {PriceAlerts.IPriceAlert=} [properties] Properties to set
     */
    function PriceAlert(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * PriceAlert price.
     * @member {number} price
     * @memberof PriceAlerts.PriceAlert
     * @instance
     */
    PriceAlert.prototype.price = 0;

    /**
     * PriceAlert crossing.
     * @member {PriceAlerts.PriceAlert.Crossing} crossing
     * @memberof PriceAlerts.PriceAlert
     * @instance
     */
    PriceAlert.prototype.crossing = 0;

    /**
     * Creates a new PriceAlert instance using the specified properties.
     * @function create
     * @memberof PriceAlerts.PriceAlert
     * @static
     * @param {PriceAlerts.IPriceAlert=} [properties] Properties to set
     * @returns {PriceAlerts.PriceAlert} PriceAlert instance
     */
    PriceAlert.create = function create(properties) {
      return new PriceAlert(properties);
    };

    /**
     * Encodes the specified PriceAlert message. Does not implicitly {@link PriceAlerts.PriceAlert.verify|verify} messages.
     * @function encode
     * @memberof PriceAlerts.PriceAlert
     * @static
     * @param {PriceAlerts.IPriceAlert} message PriceAlert message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceAlert.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.price != null && Object.hasOwnProperty.call(message, 'price'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.price);
      if (message.crossing != null && Object.hasOwnProperty.call(message, 'crossing'))
        writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.crossing);
      return writer;
    };

    /**
     * Encodes the specified PriceAlert message, length delimited. Does not implicitly {@link PriceAlerts.PriceAlert.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceAlerts.PriceAlert
     * @static
     * @param {PriceAlerts.IPriceAlert} message PriceAlert message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceAlert.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PriceAlert message from the specified reader or buffer.
     * @function decode
     * @memberof PriceAlerts.PriceAlert
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceAlerts.PriceAlert} PriceAlert
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceAlert.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.PriceAlerts.PriceAlert();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.price = reader.double();
            break;
          case 6:
            message.crossing = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a PriceAlert message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceAlerts.PriceAlert
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceAlerts.PriceAlert} PriceAlert
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceAlert.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PriceAlert message.
     * @function verify
     * @memberof PriceAlerts.PriceAlert
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PriceAlert.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.price != null && message.hasOwnProperty('price'))
        if (typeof message.price !== 'number') return 'price: number expected';
      if (message.crossing != null && message.hasOwnProperty('crossing'))
        switch (message.crossing) {
          default:
            return 'crossing: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      return null;
    };

    /**
     * Creates a PriceAlert message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceAlerts.PriceAlert
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceAlerts.PriceAlert} PriceAlert
     */
    PriceAlert.fromObject = function fromObject(object) {
      if (object instanceof $root.PriceAlerts.PriceAlert) return object;
      let message = new $root.PriceAlerts.PriceAlert();
      if (object.price != null) message.price = Number(object.price);
      switch (object.crossing) {
        case 'UNKNOWN':
        case 0:
          message.crossing = 0;
          break;
        case 'UP':
        case 1:
          message.crossing = 1;
          break;
        case 'DOWN':
        case 2:
          message.crossing = 2;
          break;
      }
      return message;
    };

    /**
     * Creates a plain object from a PriceAlert message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceAlerts.PriceAlert
     * @static
     * @param {PriceAlerts.PriceAlert} message PriceAlert
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PriceAlert.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.price = 0;
        object.crossing = options.enums === String ? 'UNKNOWN' : 0;
      }
      if (message.price != null && message.hasOwnProperty('price'))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.crossing != null && message.hasOwnProperty('crossing'))
        object.crossing =
          options.enums === String ? $root.PriceAlerts.PriceAlert.Crossing[message.crossing] : message.crossing;
      return object;
    };

    /**
     * Converts this PriceAlert to JSON.
     * @function toJSON
     * @memberof PriceAlerts.PriceAlert
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PriceAlert.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Crossing enum.
     * @name PriceAlerts.PriceAlert.Crossing
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} UP=1 UP value
     * @property {number} DOWN=2 DOWN value
     */
    PriceAlert.Crossing = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNKNOWN')] = 0;
      values[(valuesById[1] = 'UP')] = 1;
      values[(valuesById[2] = 'DOWN')] = 2;
      return values;
    })();

    return PriceAlert;
  })();

  PriceAlerts.GetAlertsResponse = (function () {
    /**
     * Properties of a GetAlertsResponse.
     * @memberof PriceAlerts
     * @interface IGetAlertsResponse
     * @property {Array.<PriceAlerts.IAlert>|null} [alerts] GetAlertsResponse alerts
     */

    /**
     * Constructs a new GetAlertsResponse.
     * @memberof PriceAlerts
     * @classdesc Represents a GetAlertsResponse.
     * @implements IGetAlertsResponse
     * @constructor
     * @param {PriceAlerts.IGetAlertsResponse=} [properties] Properties to set
     */
    function GetAlertsResponse(properties) {
      this.alerts = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetAlertsResponse alerts.
     * @member {Array.<PriceAlerts.IAlert>} alerts
     * @memberof PriceAlerts.GetAlertsResponse
     * @instance
     */
    GetAlertsResponse.prototype.alerts = $util.emptyArray;

    /**
     * Creates a new GetAlertsResponse instance using the specified properties.
     * @function create
     * @memberof PriceAlerts.GetAlertsResponse
     * @static
     * @param {PriceAlerts.IGetAlertsResponse=} [properties] Properties to set
     * @returns {PriceAlerts.GetAlertsResponse} GetAlertsResponse instance
     */
    GetAlertsResponse.create = function create(properties) {
      return new GetAlertsResponse(properties);
    };

    /**
     * Encodes the specified GetAlertsResponse message. Does not implicitly {@link PriceAlerts.GetAlertsResponse.verify|verify} messages.
     * @function encode
     * @memberof PriceAlerts.GetAlertsResponse
     * @static
     * @param {PriceAlerts.IGetAlertsResponse} message GetAlertsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetAlertsResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.alerts != null && message.alerts.length)
        for (let i = 0; i < message.alerts.length; ++i)
          $root.PriceAlerts.Alert.encode(message.alerts[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified GetAlertsResponse message, length delimited. Does not implicitly {@link PriceAlerts.GetAlertsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceAlerts.GetAlertsResponse
     * @static
     * @param {PriceAlerts.IGetAlertsResponse} message GetAlertsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetAlertsResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetAlertsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof PriceAlerts.GetAlertsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceAlerts.GetAlertsResponse} GetAlertsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetAlertsResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.PriceAlerts.GetAlertsResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.alerts && message.alerts.length)) message.alerts = [];
            message.alerts.push($root.PriceAlerts.Alert.decode(reader, reader.uint32()));
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetAlertsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceAlerts.GetAlertsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceAlerts.GetAlertsResponse} GetAlertsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetAlertsResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetAlertsResponse message.
     * @function verify
     * @memberof PriceAlerts.GetAlertsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetAlertsResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.alerts != null && message.hasOwnProperty('alerts')) {
        if (!Array.isArray(message.alerts)) return 'alerts: array expected';
        for (let i = 0; i < message.alerts.length; ++i) {
          let error = $root.PriceAlerts.Alert.verify(message.alerts[i]);
          if (error) return 'alerts.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a GetAlertsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceAlerts.GetAlertsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceAlerts.GetAlertsResponse} GetAlertsResponse
     */
    GetAlertsResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.PriceAlerts.GetAlertsResponse) return object;
      let message = new $root.PriceAlerts.GetAlertsResponse();
      if (object.alerts) {
        if (!Array.isArray(object.alerts)) throw TypeError('.PriceAlerts.GetAlertsResponse.alerts: array expected');
        message.alerts = [];
        for (let i = 0; i < object.alerts.length; ++i) {
          if (typeof object.alerts[i] !== 'object')
            throw TypeError('.PriceAlerts.GetAlertsResponse.alerts: object expected');
          message.alerts[i] = $root.PriceAlerts.Alert.fromObject(object.alerts[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a GetAlertsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceAlerts.GetAlertsResponse
     * @static
     * @param {PriceAlerts.GetAlertsResponse} message GetAlertsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetAlertsResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.alerts = [];
      if (message.alerts && message.alerts.length) {
        object.alerts = [];
        for (let j = 0; j < message.alerts.length; ++j)
          object.alerts[j] = $root.PriceAlerts.Alert.toObject(message.alerts[j], options);
      }
      return object;
    };

    /**
     * Converts this GetAlertsResponse to JSON.
     * @function toJSON
     * @memberof PriceAlerts.GetAlertsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetAlertsResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetAlertsResponse;
  })();

  PriceAlerts.GetAlertResponse = (function () {
    /**
     * Properties of a GetAlertResponse.
     * @memberof PriceAlerts
     * @interface IGetAlertResponse
     * @property {PriceAlerts.IAlert|null} [alert] GetAlertResponse alert
     */

    /**
     * Constructs a new GetAlertResponse.
     * @memberof PriceAlerts
     * @classdesc Represents a GetAlertResponse.
     * @implements IGetAlertResponse
     * @constructor
     * @param {PriceAlerts.IGetAlertResponse=} [properties] Properties to set
     */
    function GetAlertResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetAlertResponse alert.
     * @member {PriceAlerts.IAlert|null|undefined} alert
     * @memberof PriceAlerts.GetAlertResponse
     * @instance
     */
    GetAlertResponse.prototype.alert = null;

    /**
     * Creates a new GetAlertResponse instance using the specified properties.
     * @function create
     * @memberof PriceAlerts.GetAlertResponse
     * @static
     * @param {PriceAlerts.IGetAlertResponse=} [properties] Properties to set
     * @returns {PriceAlerts.GetAlertResponse} GetAlertResponse instance
     */
    GetAlertResponse.create = function create(properties) {
      return new GetAlertResponse(properties);
    };

    /**
     * Encodes the specified GetAlertResponse message. Does not implicitly {@link PriceAlerts.GetAlertResponse.verify|verify} messages.
     * @function encode
     * @memberof PriceAlerts.GetAlertResponse
     * @static
     * @param {PriceAlerts.IGetAlertResponse} message GetAlertResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetAlertResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.alert != null && Object.hasOwnProperty.call(message, 'alert'))
        $root.PriceAlerts.Alert.encode(message.alert, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified GetAlertResponse message, length delimited. Does not implicitly {@link PriceAlerts.GetAlertResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceAlerts.GetAlertResponse
     * @static
     * @param {PriceAlerts.IGetAlertResponse} message GetAlertResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetAlertResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetAlertResponse message from the specified reader or buffer.
     * @function decode
     * @memberof PriceAlerts.GetAlertResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceAlerts.GetAlertResponse} GetAlertResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetAlertResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.PriceAlerts.GetAlertResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.alert = $root.PriceAlerts.Alert.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetAlertResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceAlerts.GetAlertResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceAlerts.GetAlertResponse} GetAlertResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetAlertResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetAlertResponse message.
     * @function verify
     * @memberof PriceAlerts.GetAlertResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetAlertResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.alert != null && message.hasOwnProperty('alert')) {
        let error = $root.PriceAlerts.Alert.verify(message.alert);
        if (error) return 'alert.' + error;
      }
      return null;
    };

    /**
     * Creates a GetAlertResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceAlerts.GetAlertResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceAlerts.GetAlertResponse} GetAlertResponse
     */
    GetAlertResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.PriceAlerts.GetAlertResponse) return object;
      let message = new $root.PriceAlerts.GetAlertResponse();
      if (object.alert != null) {
        if (typeof object.alert !== 'object') throw TypeError('.PriceAlerts.GetAlertResponse.alert: object expected');
        message.alert = $root.PriceAlerts.Alert.fromObject(object.alert);
      }
      return message;
    };

    /**
     * Creates a plain object from a GetAlertResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceAlerts.GetAlertResponse
     * @static
     * @param {PriceAlerts.GetAlertResponse} message GetAlertResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetAlertResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.alert = null;
      if (message.alert != null && message.hasOwnProperty('alert'))
        object.alert = $root.PriceAlerts.Alert.toObject(message.alert, options);
      return object;
    };

    /**
     * Converts this GetAlertResponse to JSON.
     * @function toJSON
     * @memberof PriceAlerts.GetAlertResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetAlertResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetAlertResponse;
  })();

  PriceAlerts.PostAlertResponse = (function () {
    /**
     * Properties of a PostAlertResponse.
     * @memberof PriceAlerts
     * @interface IPostAlertResponse
     * @property {string|null} [uuid] PostAlertResponse uuid
     */

    /**
     * Constructs a new PostAlertResponse.
     * @memberof PriceAlerts
     * @classdesc Represents a PostAlertResponse.
     * @implements IPostAlertResponse
     * @constructor
     * @param {PriceAlerts.IPostAlertResponse=} [properties] Properties to set
     */
    function PostAlertResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * PostAlertResponse uuid.
     * @member {string} uuid
     * @memberof PriceAlerts.PostAlertResponse
     * @instance
     */
    PostAlertResponse.prototype.uuid = '';

    /**
     * Creates a new PostAlertResponse instance using the specified properties.
     * @function create
     * @memberof PriceAlerts.PostAlertResponse
     * @static
     * @param {PriceAlerts.IPostAlertResponse=} [properties] Properties to set
     * @returns {PriceAlerts.PostAlertResponse} PostAlertResponse instance
     */
    PostAlertResponse.create = function create(properties) {
      return new PostAlertResponse(properties);
    };

    /**
     * Encodes the specified PostAlertResponse message. Does not implicitly {@link PriceAlerts.PostAlertResponse.verify|verify} messages.
     * @function encode
     * @memberof PriceAlerts.PostAlertResponse
     * @static
     * @param {PriceAlerts.IPostAlertResponse} message PostAlertResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PostAlertResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.uuid != null && Object.hasOwnProperty.call(message, 'uuid'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.uuid);
      return writer;
    };

    /**
     * Encodes the specified PostAlertResponse message, length delimited. Does not implicitly {@link PriceAlerts.PostAlertResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceAlerts.PostAlertResponse
     * @static
     * @param {PriceAlerts.IPostAlertResponse} message PostAlertResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PostAlertResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PostAlertResponse message from the specified reader or buffer.
     * @function decode
     * @memberof PriceAlerts.PostAlertResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceAlerts.PostAlertResponse} PostAlertResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PostAlertResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.PriceAlerts.PostAlertResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.uuid = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a PostAlertResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceAlerts.PostAlertResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceAlerts.PostAlertResponse} PostAlertResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PostAlertResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PostAlertResponse message.
     * @function verify
     * @memberof PriceAlerts.PostAlertResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PostAlertResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.uuid != null && message.hasOwnProperty('uuid'))
        if (!$util.isString(message.uuid)) return 'uuid: string expected';
      return null;
    };

    /**
     * Creates a PostAlertResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceAlerts.PostAlertResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceAlerts.PostAlertResponse} PostAlertResponse
     */
    PostAlertResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.PriceAlerts.PostAlertResponse) return object;
      let message = new $root.PriceAlerts.PostAlertResponse();
      if (object.uuid != null) message.uuid = String(object.uuid);
      return message;
    };

    /**
     * Creates a plain object from a PostAlertResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceAlerts.PostAlertResponse
     * @static
     * @param {PriceAlerts.PostAlertResponse} message PostAlertResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PostAlertResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.uuid = '';
      if (message.uuid != null && message.hasOwnProperty('uuid')) object.uuid = message.uuid;
      return object;
    };

    /**
     * Converts this PostAlertResponse to JSON.
     * @function toJSON
     * @memberof PriceAlerts.PostAlertResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PostAlertResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PostAlertResponse;
  })();

  PriceAlerts.PostAlertRequest = (function () {
    /**
     * Properties of a PostAlertRequest.
     * @memberof PriceAlerts
     * @interface IPostAlertRequest
     * @property {PriceAlerts.IAlert|null} [alert] PostAlertRequest alert
     */

    /**
     * Constructs a new PostAlertRequest.
     * @memberof PriceAlerts
     * @classdesc Represents a PostAlertRequest.
     * @implements IPostAlertRequest
     * @constructor
     * @param {PriceAlerts.IPostAlertRequest=} [properties] Properties to set
     */
    function PostAlertRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * PostAlertRequest alert.
     * @member {PriceAlerts.IAlert|null|undefined} alert
     * @memberof PriceAlerts.PostAlertRequest
     * @instance
     */
    PostAlertRequest.prototype.alert = null;

    /**
     * Creates a new PostAlertRequest instance using the specified properties.
     * @function create
     * @memberof PriceAlerts.PostAlertRequest
     * @static
     * @param {PriceAlerts.IPostAlertRequest=} [properties] Properties to set
     * @returns {PriceAlerts.PostAlertRequest} PostAlertRequest instance
     */
    PostAlertRequest.create = function create(properties) {
      return new PostAlertRequest(properties);
    };

    /**
     * Encodes the specified PostAlertRequest message. Does not implicitly {@link PriceAlerts.PostAlertRequest.verify|verify} messages.
     * @function encode
     * @memberof PriceAlerts.PostAlertRequest
     * @static
     * @param {PriceAlerts.IPostAlertRequest} message PostAlertRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PostAlertRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.alert != null && Object.hasOwnProperty.call(message, 'alert'))
        $root.PriceAlerts.Alert.encode(message.alert, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified PostAlertRequest message, length delimited. Does not implicitly {@link PriceAlerts.PostAlertRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceAlerts.PostAlertRequest
     * @static
     * @param {PriceAlerts.IPostAlertRequest} message PostAlertRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PostAlertRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PostAlertRequest message from the specified reader or buffer.
     * @function decode
     * @memberof PriceAlerts.PostAlertRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceAlerts.PostAlertRequest} PostAlertRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PostAlertRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.PriceAlerts.PostAlertRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.alert = $root.PriceAlerts.Alert.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a PostAlertRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceAlerts.PostAlertRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceAlerts.PostAlertRequest} PostAlertRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PostAlertRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PostAlertRequest message.
     * @function verify
     * @memberof PriceAlerts.PostAlertRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PostAlertRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.alert != null && message.hasOwnProperty('alert')) {
        let error = $root.PriceAlerts.Alert.verify(message.alert);
        if (error) return 'alert.' + error;
      }
      return null;
    };

    /**
     * Creates a PostAlertRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceAlerts.PostAlertRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceAlerts.PostAlertRequest} PostAlertRequest
     */
    PostAlertRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.PriceAlerts.PostAlertRequest) return object;
      let message = new $root.PriceAlerts.PostAlertRequest();
      if (object.alert != null) {
        if (typeof object.alert !== 'object') throw TypeError('.PriceAlerts.PostAlertRequest.alert: object expected');
        message.alert = $root.PriceAlerts.Alert.fromObject(object.alert);
      }
      return message;
    };

    /**
     * Creates a plain object from a PostAlertRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceAlerts.PostAlertRequest
     * @static
     * @param {PriceAlerts.PostAlertRequest} message PostAlertRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PostAlertRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.alert = null;
      if (message.alert != null && message.hasOwnProperty('alert'))
        object.alert = $root.PriceAlerts.Alert.toObject(message.alert, options);
      return object;
    };

    /**
     * Converts this PostAlertRequest to JSON.
     * @function toJSON
     * @memberof PriceAlerts.PostAlertRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PostAlertRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PostAlertRequest;
  })();

  PriceAlerts.PutAlertRequest = (function () {
    /**
     * Properties of a PutAlertRequest.
     * @memberof PriceAlerts
     * @interface IPutAlertRequest
     * @property {PriceAlerts.IAlert|null} [alert] PutAlertRequest alert
     */

    /**
     * Constructs a new PutAlertRequest.
     * @memberof PriceAlerts
     * @classdesc Represents a PutAlertRequest.
     * @implements IPutAlertRequest
     * @constructor
     * @param {PriceAlerts.IPutAlertRequest=} [properties] Properties to set
     */
    function PutAlertRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * PutAlertRequest alert.
     * @member {PriceAlerts.IAlert|null|undefined} alert
     * @memberof PriceAlerts.PutAlertRequest
     * @instance
     */
    PutAlertRequest.prototype.alert = null;

    /**
     * Creates a new PutAlertRequest instance using the specified properties.
     * @function create
     * @memberof PriceAlerts.PutAlertRequest
     * @static
     * @param {PriceAlerts.IPutAlertRequest=} [properties] Properties to set
     * @returns {PriceAlerts.PutAlertRequest} PutAlertRequest instance
     */
    PutAlertRequest.create = function create(properties) {
      return new PutAlertRequest(properties);
    };

    /**
     * Encodes the specified PutAlertRequest message. Does not implicitly {@link PriceAlerts.PutAlertRequest.verify|verify} messages.
     * @function encode
     * @memberof PriceAlerts.PutAlertRequest
     * @static
     * @param {PriceAlerts.IPutAlertRequest} message PutAlertRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PutAlertRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.alert != null && Object.hasOwnProperty.call(message, 'alert'))
        $root.PriceAlerts.Alert.encode(message.alert, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified PutAlertRequest message, length delimited. Does not implicitly {@link PriceAlerts.PutAlertRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceAlerts.PutAlertRequest
     * @static
     * @param {PriceAlerts.IPutAlertRequest} message PutAlertRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PutAlertRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PutAlertRequest message from the specified reader or buffer.
     * @function decode
     * @memberof PriceAlerts.PutAlertRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceAlerts.PutAlertRequest} PutAlertRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PutAlertRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.PriceAlerts.PutAlertRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.alert = $root.PriceAlerts.Alert.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a PutAlertRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceAlerts.PutAlertRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceAlerts.PutAlertRequest} PutAlertRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PutAlertRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PutAlertRequest message.
     * @function verify
     * @memberof PriceAlerts.PutAlertRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PutAlertRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.alert != null && message.hasOwnProperty('alert')) {
        let error = $root.PriceAlerts.Alert.verify(message.alert);
        if (error) return 'alert.' + error;
      }
      return null;
    };

    /**
     * Creates a PutAlertRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceAlerts.PutAlertRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceAlerts.PutAlertRequest} PutAlertRequest
     */
    PutAlertRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.PriceAlerts.PutAlertRequest) return object;
      let message = new $root.PriceAlerts.PutAlertRequest();
      if (object.alert != null) {
        if (typeof object.alert !== 'object') throw TypeError('.PriceAlerts.PutAlertRequest.alert: object expected');
        message.alert = $root.PriceAlerts.Alert.fromObject(object.alert);
      }
      return message;
    };

    /**
     * Creates a plain object from a PutAlertRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceAlerts.PutAlertRequest
     * @static
     * @param {PriceAlerts.PutAlertRequest} message PutAlertRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PutAlertRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.alert = null;
      if (message.alert != null && message.hasOwnProperty('alert'))
        object.alert = $root.PriceAlerts.Alert.toObject(message.alert, options);
      return object;
    };

    /**
     * Converts this PutAlertRequest to JSON.
     * @function toJSON
     * @memberof PriceAlerts.PutAlertRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PutAlertRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PutAlertRequest;
  })();

  PriceAlerts.PostCallbackRequest = (function () {
    /**
     * Properties of a PostCallbackRequest.
     * @memberof PriceAlerts
     * @interface IPostCallbackRequest
     * @property {PriceAlerts.IAlert|null} [alert] PostCallbackRequest alert
     */

    /**
     * Constructs a new PostCallbackRequest.
     * @memberof PriceAlerts
     * @classdesc Represents a PostCallbackRequest.
     * @implements IPostCallbackRequest
     * @constructor
     * @param {PriceAlerts.IPostCallbackRequest=} [properties] Properties to set
     */
    function PostCallbackRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * PostCallbackRequest alert.
     * @member {PriceAlerts.IAlert|null|undefined} alert
     * @memberof PriceAlerts.PostCallbackRequest
     * @instance
     */
    PostCallbackRequest.prototype.alert = null;

    /**
     * Creates a new PostCallbackRequest instance using the specified properties.
     * @function create
     * @memberof PriceAlerts.PostCallbackRequest
     * @static
     * @param {PriceAlerts.IPostCallbackRequest=} [properties] Properties to set
     * @returns {PriceAlerts.PostCallbackRequest} PostCallbackRequest instance
     */
    PostCallbackRequest.create = function create(properties) {
      return new PostCallbackRequest(properties);
    };

    /**
     * Encodes the specified PostCallbackRequest message. Does not implicitly {@link PriceAlerts.PostCallbackRequest.verify|verify} messages.
     * @function encode
     * @memberof PriceAlerts.PostCallbackRequest
     * @static
     * @param {PriceAlerts.IPostCallbackRequest} message PostCallbackRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PostCallbackRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.alert != null && Object.hasOwnProperty.call(message, 'alert'))
        $root.PriceAlerts.Alert.encode(message.alert, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified PostCallbackRequest message, length delimited. Does not implicitly {@link PriceAlerts.PostCallbackRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceAlerts.PostCallbackRequest
     * @static
     * @param {PriceAlerts.IPostCallbackRequest} message PostCallbackRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PostCallbackRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PostCallbackRequest message from the specified reader or buffer.
     * @function decode
     * @memberof PriceAlerts.PostCallbackRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceAlerts.PostCallbackRequest} PostCallbackRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PostCallbackRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.PriceAlerts.PostCallbackRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.alert = $root.PriceAlerts.Alert.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a PostCallbackRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceAlerts.PostCallbackRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceAlerts.PostCallbackRequest} PostCallbackRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PostCallbackRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PostCallbackRequest message.
     * @function verify
     * @memberof PriceAlerts.PostCallbackRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PostCallbackRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.alert != null && message.hasOwnProperty('alert')) {
        let error = $root.PriceAlerts.Alert.verify(message.alert);
        if (error) return 'alert.' + error;
      }
      return null;
    };

    /**
     * Creates a PostCallbackRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceAlerts.PostCallbackRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceAlerts.PostCallbackRequest} PostCallbackRequest
     */
    PostCallbackRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.PriceAlerts.PostCallbackRequest) return object;
      let message = new $root.PriceAlerts.PostCallbackRequest();
      if (object.alert != null) {
        if (typeof object.alert !== 'object')
          throw TypeError('.PriceAlerts.PostCallbackRequest.alert: object expected');
        message.alert = $root.PriceAlerts.Alert.fromObject(object.alert);
      }
      return message;
    };

    /**
     * Creates a plain object from a PostCallbackRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceAlerts.PostCallbackRequest
     * @static
     * @param {PriceAlerts.PostCallbackRequest} message PostCallbackRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PostCallbackRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.alert = null;
      if (message.alert != null && message.hasOwnProperty('alert'))
        object.alert = $root.PriceAlerts.Alert.toObject(message.alert, options);
      return object;
    };

    /**
     * Converts this PostCallbackRequest to JSON.
     * @function toJSON
     * @memberof PriceAlerts.PostCallbackRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PostCallbackRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PostCallbackRequest;
  })();

  return PriceAlerts;
})());

export { $root as default };
